$(".allpbspb-extended-search__toggler").on("click", function () {
	$(".allpbspb-extended-search__content").toggleClass("active");
});

$(document).on("click", function (e) {
	if ($(".allpbspb-objects__actions-popup").hasClass("active")) {
		var callbackPopup = $(".allpbspb-objects__actions-popup, .allpbspb-objects__open-actions-popup");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".allpbspb-objects__actions-popup").removeClass("active");
		};
	}
});

if ($(".allpb-object-notify__table tbody tr").length > 3) {
    $(".allpb-object-notify__show-all-element").show();

    $(".allpb-object-notify__show-all").on("click", function () {
        $(this).text(function(i, v){
            return v === 'Показать все' ? 'Показать три' : 'Показать все'
        });
        $(".allpb-object-notify__table tbody tr:nth-of-type(n + 4)").toggleClass("active");
    });
} else {
    $(".allpb-object-notify__show-all-element").hide();
}

